document.addEventListener("DOMContentLoaded", function (event) {
  const installmentPopup = document.getElementById("installmentPopup");

  // Function to initialize event listeners
  function initializeEventListeners() {
    const moreInfoButtons = document.querySelectorAll(".learnMore");
    const installmentPopup = document.getElementById("installmentPopup");

    const closePopup = document.getElementById("closePopup");

    // Add event listeners to all "Learn More" buttons
    moreInfoButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        installmentPopup.style.display = "flex";
      });
    });

    // Event listener to close the popup
    closePopup?.addEventListener("click", () => {
      installmentPopup.style.display = "none";
    });

    // Close the popup when clicking outside the popup content
    installmentPopup?.addEventListener("click", (e) => {
      if (e.target === installmentPopup) {
        installmentPopup.style.display = "none";
      }
    });
  }

  // Initial event listener initialization
  initializeEventListeners();
});

document.addEventListener("DOMContentLoaded", function () {
  let isUpdatingCart = false;

  // Global event delegation for variant dropdowns
  document.body.addEventListener("change", function (event) {
    const dropdown = event.target.closest(".variant-dropdown");
    if (dropdown) {
      handleVariantChange(dropdown);
    }
  });

  // Check if all collection products are in cart
  function checkAllProductsInCart() {
    const collectionSection = document.querySelector(".collection-item");
    if (!collectionSection) return;

    const productCards = document.querySelectorAll(".product-card");
    if (productCards.length === 0) {
      // If no products left to display, hide the entire collection section
      collectionSection.innerHTML =
        "<p class='no-products-message'>No recommended product</p>";

      // Optional: Remove the element completely after animation
      setTimeout(() => {
        collectionSection.remove();
      }, 300); // Adjust timing if you have CSS transitions
    }
  }

  // Handle add to cart functionality
  async function handleAddToCart(button) {
    try {
      // Update cart drawer
      await updateCartDrawer();
    } catch (error) {
    } finally {
    }
  }

  // Handle variant changes
  function handleVariantChange(dropdown) {
    const productId = dropdown.dataset.productId;
    const selectedVariantId = dropdown.value;
    const selectedOption = dropdown.options[dropdown.selectedIndex];

    if (!productId || !selectedVariantId) {
      console.error("Missing product ID or variant ID");
      return;
    }

    // Update product image
    // updateProductImage(productId, selectedOption);

    // Update product price
    updateProductPrice(productId, selectedOption);

    // Update add to cart button
    updateAddToCartButton(productId, selectedVariantId, dropdown);
  }

  // Update product image
  function updateProductImage(productId, selectedOption) {
    const imageElement = document.getElementById(`product-image-${productId}`);
    if (!imageElement) return;

    const imageUrl = selectedOption.dataset.image;

    // Only update if there's a new image URL
    if (imageUrl) {
      // Store original image URL if not already stored
      if (!imageElement.getAttribute("data-original-src")) {
        imageElement.setAttribute("data-original-src", imageElement.src);
      }
      imageElement.src = imageUrl;
    } else {
      // Revert to original image if no variant image
      const originalSrc = imageElement.getAttribute("data-original-src");
      if (originalSrc) {
        imageElement.src = originalSrc;
      }
    }
  }

  // Update product price
  function updateProductPrice(productId, selectedOption) {
    const priceElement = document.getElementById(`product-price-${productId}`);
    if (!priceElement) return;

    const price = selectedOption.dataset.price;
    const comparePrice = selectedOption.dataset.comparePrice;

    let priceHtml = `<span class="current-price-cart-collection">${price}</span>`;
    if (comparePrice && comparePrice !== "" && comparePrice !== price) {
      priceHtml += `<span class="compare-price-cart-collection">${comparePrice}</span>`;
    }

    priceElement.innerHTML = priceHtml;
  }

  // Update add to cart button
  function updateAddToCartButton(productId, variantId, dropdown) {
    const productCard = document.getElementById(`product-card-${productId}`);

    if (!productCard) return;

    const addToCartButtonVariant = productCard.querySelector(
      ".product-variant-id"
    );
    const selectedOption = dropdown.options[dropdown.selectedIndex];
    const variantAvaiibility = selectedOption.getAttribute("data-avaibility");
    if (variantAvaiibility === "false") {
      productCard
        .querySelector(".product-form__submit")
        .setAttribute("disabled", true);
      productCard.querySelector(".product-form__submit span").textContent =
        "Sold Out";
    } else {
      productCard
        .querySelector(".product-form__submit")
        .removeAttribute("disabled", true);
      productCard.querySelector(".product-form__submit span").textContent =
        "Add to cart";
    }

    if (addToCartButtonVariant) {
      addToCartButtonVariant.value = variantId;
    }
  }

  // Update cart drawer
  async function updateCartDrawer() {
    const cartForm = document.getElementById("CartDrawer-Form");
    if (!cartForm) {
      console.error("Cart drawer form not found");
      return;
    }

    try {
      const response = await fetch(
        `${window.location.pathname}?section_id=cart-drawer`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newForm = doc.getElementById("CartDrawer-Form");

      if (newForm) {
        cartForm.innerHTML = newForm.innerHTML;

        // Refresh upsell section if it exists in the new content
        const upsellSection = doc.querySelector(".collection-inner-data-cart");
        const currentUpsellSection = document.querySelector(
          ".collection-inner-data-cart"
        );

        if (upsellSection && currentUpsellSection) {
          currentUpsellSection.innerHTML = upsellSection.innerHTML;
          initializeProductOrder();
          // Check if we should hide the section after updating
          setTimeout(() => {
            checkAllProductsInCart();
          }, 100); // 100ms delay ensures DOM update before checking
        } else if (currentUpsellSection) {
          currentUpsellSection.innerHTML = "<p>No recommended product</p>";
        }
      } else {
        throw new Error("New cart form content not found in response");
      }
    } catch (error) {
      console.error("Error updating cart drawer:", error);
    }
  }

    window.DuuduuCart = window.DuuduuCart || {};
    window.DuuduuCart.updateCartDrawer = updateCartDrawer;


  // Initialize product order randomization
  function initializeProductOrder() {
    const container = document.querySelector(".collection-inner-data-cart");
    if (!container) return;

    try {
      const products = Array.from(container.children);
      for (let i = products.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        container.appendChild(products[j]);
      }
    } catch (error) {
      console.error("Error randomizing products:", error);
    }
  }

  // Run initial setup
  initializeProductOrder();
  checkAllProductsInCart(); // Check initial state
});


document.addEventListener('DOMContentLoaded', () => {
  const drawerContents = document.querySelector('.drawer__contents.js-contents');

  if (!drawerContents) return;

  // Observe height changes
  const observer = new ResizeObserver(() => {
    drawerContents.style.overflowY = 'auto';
  });
  observer.observe(drawerContents);

  // 🔁 Periodic fallback in case lazy content loads silently
  setTimeout(() => {
    drawerContents.style.overflowY = 'hidden';
    requestAnimationFrame(() => {
      drawerContents.style.overflowY = 'auto';
    });
  }, 1000); // Delay long enough for upsell products to load
});





// Safe cashback text updater that won't break other functions
function updateCashbackText() {
  // Find all text nodes and update them individually (preserves event listeners)
  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );

  let node;
  const nodesToUpdate = [];
  
  // Collect all text nodes that need updating
  while (node = walker.nextNode()) {
    const text = node.textContent;
    if (text.includes('$150 Cashback') || text.includes('$150 OFF') || text.includes('Get $150 OFF')) {
      nodesToUpdate.push(node);
    }
  }
  
  // Update the text nodes
  nodesToUpdate.forEach(node => {
    node.textContent = node.textContent
      .replace(/\$150 Cashback/g, '$50 Cashback')
      .replace(/\$150 OFF/g, '$50 OFF')
      .replace(/Get \$150 OFF/g, 'Get $50 OFF');
  });
  
  if (nodesToUpdate.length > 0) {
    console.log('✅ Cashback text updated safely');
  }
}

// Run when page loads
document.addEventListener('DOMContentLoaded', updateCashbackText);

// Also run after a short delay (catches slow-loading content)
setTimeout(updateCashbackText, 1000);






// Save selection to Shopify cart attribute
function duuduuInitTradeInSave() {

  const inputs = document.querySelectorAll('.duuduu-tradein-input');

  inputs.forEach(input => {

    input.addEventListener("change", function() {

      fetch('/cart/update.js', {

        method: 'POST',

        headers: {
          'Content-Type': 'application/json'
        },

        body: JSON.stringify({
          attributes: {
            "Trade in": this.value
          }
        })

      });

    });

  });

}



// Load saved cart attribute
function duuduuInitTradeInLoad() {

  fetch('/cart.js')

    .then(res => res.json())

    .then(cart => {

      const value = cart.attributes["Trade in"];

      if (value === "yes") {

        const yes = document.getElementById("duuduu-tradein-yes");
        if (yes) yes.checked = true;

      } else {

        const no = document.getElementById("duuduu-tradein-no");
        if (no) no.checked = true;

      }

    });

}



// Initialize everything
function duuduuInitTradeIn() {

  duuduuInitTradeInSave();
  duuduuInitTradeInLoad();

}



// Run when page loads
document.addEventListener("DOMContentLoaded", duuduuInitTradeIn);



// Run again if cart drawer reloads (important for cart apps)
document.addEventListener("shopify:section:load", duuduuInitTradeIn);



